/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { storyblokEditable } from '@storyblok/react/rsc'
import React from 'react'
import { ManualRichTextRenderer } from '@/components/dashboard/manuals/ui/ManualRichtextRenderer'
import { TypographyStoryblok } from '@/lib/storyblok/types/generated-types'

/** A description of the available properties for this component. */
type TypographyProps = {
  /** The Storyblok blok that represents this component. */
  blok: TypographyStoryblok
}

/**
 * A Storyblok component for displaying typography, specific to the kit manuals.
 */
const StoryblokTypographyManuals: React.FC<TypographyProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <ManualRichTextRenderer document={blok.text} />
    </div>
  )
}

export { StoryblokTypographyManuals }
